var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-1195.000000, -34.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(1195.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.11106,1.19390714 C4.03334571,1.09110571 5.00343429,1 6,1 C6.99656571,1 7.96665429,1.09110571 8.88891429,1.19390714 C10.4214857,1.36472886 11.6520857,2.59389143 11.8164857,4.13001143 C11.9146286,5.04776286 12,6.0109 12,7 C12,7.9891 11.9146286,8.95223714 11.8164857,9.86997143 C11.6520857,11.4061429 10.4214857,12.6352857 8.88891429,12.8061143 C7.96665429,12.9088857 6.99656571,13 6,13 C5.00343429,13 4.03334571,12.9088857 3.11106,12.8061143 C1.57854,12.6352857 0.347881714,11.4061429 0.183534,9.86997143 C0.0853458857,8.95223714 0,7.9891 0,7 C0,6.01089143 0.0853457143,5.04776286 0.183534,4.13001143 C0.347880857,2.59389143 1.57854,1.36472886 3.11106,1.19390714 Z M3.88518,5.69866 C3.88518,4.53064 4.83204857,3.58377143 6.00006857,3.58377143 C7.16808857,3.58377143 8.11494857,4.53064 8.11494857,5.69866 C8.11494857,6.86668 7.16808857,7.81354 6.00006857,7.81354 C4.83204857,7.81354 3.88518,6.86668 3.88518,5.69866 Z M9.77417143,10.7107429 C9.86194286,10.8718 9.82388571,11.0734 9.67337143,11.1782286 C9.40354286,11.3660286 9.08691429,11.4903143 8.74637143,11.5282857 C7.83517714,11.6298571 6.92270571,11.7142857 5.99989714,11.7142857 C5.07709714,11.7142857 4.16461714,11.6298571 3.25338857,11.5282857 C2.91738,11.4908286 2.6046,11.3692 2.33705143,11.1855143 C2.18417143,11.0806 2.14627714,10.8762571 2.23570286,10.7137429 C2.50377429,10.2268 2.85989143,9.78554286 3.28213714,9.44041429 C4.04957143,8.81315714 5.01025714,8.47049714 6.00141429,8.47049714 C6.99258,8.47049714 7.95326571,8.81315714 8.72065714,9.44041429 C9.15377143,9.79437143 9.51025714,10.2267143 9.77417143,10.7107429 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconWhite);
export default __webpack_public_path__ + "static/media/profileIconWhite.953b0946ca459c3cf190d00332db1393.svg";
export { ForwardRef as ReactComponent };